export const enum EventsCode {
  ESCAPE = 'Escape',
}
